import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromUtilities from './store/utilities.reducer';
import { UtilitiesEffects } from './store/utilities.effects';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromUtilities.utilitiesesFeatureKey,
      fromUtilities.reducer
    ),
    EffectsModule.forFeature([UtilitiesEffects]),
  ],
})
export class UtilitiesModule {}
